import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const PUBLISH_OFFER_SUCCESS = 'PUBLISH_OFFER :: SUCCESS';

export type TPublishOfferSuccessAction = IReduxAction<typeof PUBLISH_OFFER_SUCCESS>;

export const publishOfferSuccess = actionGenerator<typeof PUBLISH_OFFER_SUCCESS>(PUBLISH_OFFER_SUCCESS);
